import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { useForm } from "react-hook-form";
import { FaCamera } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import Select, { MultiValue } from "react-select";
import { toast } from "react-toastify";
import api from "../../api/api";
import hamburger from "../../assets/icons/black-hamburger.svg";
import { BlackButton } from "../../components/black-button";
import { environment } from "../../environments/environment";
// import { HTML5Backend } from "react-dnd-html5-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import { BsTrash } from "react-icons/bs";

interface CampaignImagesProp {
  media_url: string;
  sort_id: number;
  uuid?: string;
  ID?: number;
  createdAt?: string;
  updatedAt?: string;
  DeletedAt?: string;
  campaign_id?: number;
  campaign_uuid?: string;
  media_public_id?: string;
  media_asset_id?: string;
  gallery_enabled?: boolean;
  media_title?: string;
  media_description?: string;
  isNew?: boolean;
}
interface DraggableImageProps {
  image: CampaignImagesProp;
  index: number;
  moveImage: (dragIndex: number, hoverIndex: number) => void;
  deleteImage: (identifier: string, isNew: boolean) => void;
}

const DraggableImage: React.FC<DraggableImageProps> = ({
  image,
  index,
  moveImage,
  deleteImage,
}) => {
  const [, ref] = useDrag({
    type: "IMAGE",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "IMAGE",
    hover: (draggedItem: { index: number }) => {
      if (draggedItem.index !== index) {
        moveImage(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  const cloudinaryImageUrl = image.media_url.includes("cloudinary.com")
    ? image.media_url.replace(
        "/upload/",
        "/upload/w_791,h_624,c_fit,ar_9:16,f_auto,q_auto:best,c_lpad,b_auto:predominant,e_trim/"
      )
    : image.media_url;

  return (
    <div
      ref={(node) => ref(drop(node))}
      className="relative cursor-move h-36 w-36 overflow-hidden rounded-md"
    >
      <img
        src={cloudinaryImageUrl}
        alt={`Campaign Image ${index + 1}`}
        className="w-full h-full object-cover "
      />
      <button
        onClick={() =>
          deleteImage(
            image?.isNew ? index.toString() : image.uuid || "",
            !!image.isNew
          )
        }
        className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 transition-colors"
      >
        <BsTrash size={20} />
      </button>
    </div>
  );
};

export const AdminNewCampaign = () => {
  const { uuid } = useParams(); //in case of viewing single campaign to edit
  const navigate = useNavigate();
  const [imageUrls, setImageUrls] = useState<string | null>(null);
  const [selectedSizeType, setSizeType] = useState<any>(null);
  const [selectedCategories, setCategories] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedSizeTypes, setSelectedSizeTypes] = useState<string[]>([]);
  const [newImages, setNewImages] = useState<File[]>([]);
  const [campaignImages, setCampaignImages] = useState<CampaignImagesProp[]>(
    []
  );
  const [isLocationExclusive, setIsLocationExclusive] = useState<"yes" | "no">(
    "no"
  );

  const [size, setSize] = useState<any>([]);
  const [size_ml, setSize_Ml] = useState<any>("");
  const [size_kg, setSize_Kg] = useState<any>("");
  const [size_hwl, setSize_Hwl] = useState<any>("");
  const [size_men_shoe, setSize_Men] = useState<any>([]);
  const [size_women_shoe, setSize_Women] = useState<any>([]);

  const [updateImage, setUpdateImage] = useState<any>("");
  const [updatesField, setUpdatesField] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const [categoriesList, setCategoriesList] = useState<
    { label: string; value: string }[]
  >([]);

  const {
    register,
    formState: { errors, isValid },
    setValue,
    handleSubmit,
  } = useForm();

  /**
   * Converts a single image file to a base64 string.
   * @param file - The image file to convert.
   * @returns A promise that resolves to the base64 string.
   */
  const convertImageToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        // Remove "data:" prefix and everything up to and including the first comma
        const base64String = result.replace("data:", "").replace(/^.+,/, "");
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const submitMe = async (values: any) => {
    setLoading(true);
    if (
      Number(values.production_goal_order_number) >
      Number(values.end_goal_order_number)
    ) {
      setLoading(false);
      return toast.error(
        "Production Goal Order Number should be less than End Goal Order Number"
      );
    }
    setLoading(true);
    let payload = { ...values };
    // payload.image_url = imageUrls;
    payload.production_goal_price = Number(values.production_goal_price);
    payload.end_goal_order_number = Number(values.end_goal_order_number);
    payload.end_goal_price = Number(values.end_goal_price);
    payload.minimum_quantity = Number(values.minimum_quantity);
    payload.production_goal_order_number = Number(
      values.production_goal_order_number
    );
    payload.location_exclusive = isLocationExclusive;

    if (selectedSizeType === "size") {
      payload.size = size.map((x: any) => x.value);
    } else if (selectedSizeType === "ml") {
      payload.size_ml = size_ml;
    } else if (selectedSizeType === "kg") {
      payload.size_kg = size_kg;
    } else if (selectedSizeType === "h_w_l") {
      payload.size_hwl = "";
    } else if (selectedSizeType === "men") {
      payload.size_men_shoe = size_men_shoe.map((x: any) => x.value);
    } else if (selectedSizeType === "women") {
      payload.size_women_shoe = size_women_shoe.map((x: any) => x.value);
    }

    const imagePromises = newImages.map(async (file, index) => {
      const bytes = await convertImageToBase64(file);
      const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
      return {
        media_data: bytes,
        media_name: fileNameWithoutExtension,
        media_type: file.type,
        sort_id: campaignImages.length + index + 1,
      };
    });

    const newMediaData = await Promise.all(imagePromises);

    const finalImageData = campaignImages
      .filter((img) => !img.isNew)
      .map((img, index) => ({
        uuid: img.uuid,
        sort_id: index + 1,
        // Include other necessary fields
      }));

    const combinedImages = [...finalImageData, ...newMediaData];

    payload.images = combinedImages.map((img, index) => ({
      ...img,
      sort_id: index + 1, // Final sort_id starts from 1
    }));

    if (uuid) {
      //when editting
      try {
        payload.campaign_uuid = uuid;

        if (selectedCategories[0]?.value) {
          payload.category = selectedCategories[0]?.value;
        }

        const response = await api.put(
          `${environment.baseUrl}/admin/campaign/edit`,
          payload
        );

        if (response.data.success) {
          toast.success(response.data.message);
          navigate("/admin/campaigns");
        } else {
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      //when creating
      try {
        payload.category = selectedCategories[0].value;

        const response = await api.post(
          `${environment.baseUrl}/admin/campaign/create`,
          payload
        );

        if (response.data.success) {
          toast.success(response.data.message);
          navigate("/admin/campaigns");
        } else {
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  };

  // * NEW Functions for the drag and drop functionality
  const moveImage = (fromIndex: number, toIndex: number) => {
    setCampaignImages((prevImages) => {
      const updatedImages = [...prevImages];
      const [movedImage] = updatedImages.splice(fromIndex, 1);

      // Insert the moved image at the new position
      updatedImages.splice(toIndex, 0, movedImage);

      // Reassign sort_ids starting from 1
      return updatedImages.map((img, index) => ({
        ...img,
        sort_id: index + 1, // Sort IDs starting from 1
      }));
    });
  };

  const handleNewImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const newImageFiles = Array.from(files);
      setNewImages((prevImages) => [...prevImages, ...newImageFiles]);

      setCampaignImages((prevImages) => {
        // Get the last sort_id (or start from 0)
        const lastSortId =
          prevImages.length > 0
            ? Math.max(...prevImages.map((img) => img.sort_id))
            : 0;

        const newCampaignImages = newImageFiles.map((file, index) => ({
          uuid: `new-${Date.now()}-${index}`,
          media_url: URL.createObjectURL(file),
          sort_id: lastSortId + index + 1, // Continue from the last sort_id
          isNew: true,
        }));

        // console.log(newCampaignImages);

        // Combine new and existing images, filtering duplicates
        const updatedImages = [
          ...prevImages,
          ...newCampaignImages.filter(
            (newImage) =>
              !prevImages.some((prev) => prev.media_url === newImage.media_url)
          ),
        ];

        // console.log(updatedImages);

        // Re-assign sort_id to ensure uniqueness and start from 1
        return updatedImages.map((image, index) => ({
          ...image,
          sort_id: index + 1, // Sort IDs start from 1
        }));
      });
    }
  };

  const deleteImage = async (identifier: string, isNew: boolean) => {
    if (isNew) {
      // Handle deleting new images
      const indexToDelete = parseInt(identifier);
      setCampaignImages((prevImages) => {
        const updatedImages = prevImages.filter(
          (_, index) => index !== indexToDelete
        );
        // Adjust sort_ids after deletion
        return updatedImages.map((img, index) => ({
          ...img,
          sort_id: index + 1, // Sort IDs start from 1
        }));
      });
      setNewImages((prevNewImages) =>
        prevNewImages.filter((_, index) => index !== indexToDelete)
      );
    } else {
      // Handle deleting existing images
      setCampaignImages((prevImages) => {
        const updatedImages = prevImages.filter(
          (img) => img.uuid !== identifier
        );
        // Adjust sort_ids after deletion
        return updatedImages.map((img, index) => ({
          ...img,
          sort_id: index + 1, // Sort IDs start from 1
        }));
      });
      try {
        const response = await api.delete(
          `${environment.baseUrl}/admin/campaign/image/delete/${identifier}`
        );
        if (response.data.success) {
          toast.success(response.data.message);
        }
      } catch (error) {
        console.error("Error deleting image:", error);
        toast.error("Unable to delete image, try again.");
      }
    }
  };

  const handleImageUpload = (event: any) => {
    const files = event.target.files;

    handleImage_s(files);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    handleImage_s(files);
  };

  const handleImage_s = (file_s: any) => {
    // Handle image upload here
    if (file_s && file_s[0]) {
      for (const file of file_s) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "cqom5ijc");

        axios
          .post(
            `https://api.cloudinary.com/v1_1/dlicyptzz/image/upload`,
            formData
          )
          .then((response) => {
            setImageUrls((prevImageUrls) => {
              if (prevImageUrls) {
                return prevImageUrls + "," + response.data.secure_url;
              } else {
                return response.data.secure_url;
              }
            });
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
          });
      }
    }
  };

  const handleUpdateImage = (event: any) => {
    const files = event.target.files;
    // Handle image upload here
    if (files && files[0]) {
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("upload_preset", "cqom5ijc");

      axios
        .post(
          `https://api.cloudinary.com/v1_1/dlicyptzz/image/upload`,
          formData
        )
        .then((response) => {
          setUpdateImage(response.data.secure_url);
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const fetchCategoriesList = async () => {
    try {
      const response = await api.get(`${environment.baseUrl}/admin/categories`);

      if (response.data.code == 200) {
        setCategoriesList(
          response.data.data.all_categories.map((x: any) => ({
            label: x.name,
            value: x.short_name,
          }))
        );
        if (uuid) {
          fetchCampaignDetails();
        }
      }
    } catch (error) {
      navigate("/campaigns");
    }
  };

  const fetchCampaignDetails = async () => {
    try {
      const response = await api.get(
        `${environment.baseUrl}/campaign/fetch/single/${uuid}`
      );

      if (response.data.success) {
        const data_ = response.data.data.campaign;
        setImageUrls(data_.image_url);
        setValue("campaign_title", data_.campaign_title);
        setValue("product_title", data_.product_title);
        setValue("production_goal_price", data_.production_goal_price);
        setValue(
          "production_goal_order_number",
          data_.production_goal_order_number
        );
        setValue("end_goal_price", data_.end_goal_price);
        setValue("end_goal_order_number", data_.end_goal_order_number);
        setValue("campaign_deadline", data_.campaign_deadline.split("T")[0]);
        setValue("location", data_.location);
        setValue("campaign_description", data_.campaign_description);
        setValue("minimum_quantity", data_.minimum_quantity);
        setValue("campaign_updates", data_.campaign_updates);
        setCategories([
          categoriesList.find((x) => x.value === data_.category)!,
        ]);
        setIsLocationExclusive(data_.location_exclusive);

        if (data_.size) {
          setSizeType("size");
          setSize(data_.size);
        } else if (data_.size_ml) {
          setSizeType("ml");
          setSize_Ml(data_.size_ml);
        } else if (data_.size_kg) {
          setSizeType("kg");
          setSize_Kg(data_.size_kg);
        } else if (data_.size_h_w_l) {
          setSizeType("hwl");
          setSize_Hwl(data_.size_h_w_l);
        } else if (data_.size_men_show) {
          setSizeType("men");
          setSize_Men(data_.size_men_shoe);
        } else if (data_.size_women_show) {
          setSizeType("women");
          setSize_Women(data_.size_women_shoe);
        }

        if (response.data.data.campaign_images) {
          const apiImages = response.data.data.campaign_images;
          const sortedImages = apiImages
            .sort(
              (a: CampaignImagesProp, b: CampaignImagesProp) =>
                a.sort_id - b.sort_id
            )
            .map((img: CampaignImagesProp) => ({ ...img, isNew: false }));

          // console.log(sortedImages);

          setCampaignImages(sortedImages);
        }
      }
    } catch (error) {
      navigate("/admin/campaigns");
    }
  };

  const submitUpdate = async () => {
    try {
      const response = await api.post(
        `${environment.baseUrl}/admin/campaign-update`,
        {
          text: updatesField,
          image_url: updateImage,
          campaign_uuid: uuid,
        }
      );

      if (response.data.success) {
        toast.success(response.data.message);
        setUpdatesField("");
        setUpdateImage(null);
      } else {
      }
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    fetchCategoriesList();
  }, []);

  // const [campaignDetails, setCampaignDetails] = useState<any>(initialValues);

  return (
    <section className="font-montserrat">
      <div className="flex items-center gap-3">
        <img src={hamburger} alt="campaigns-icon" className="w-[18px]" />
        <h5 className="text-[22px] text-[#0E203F] font-bold">Campaigns</h5>
      </div>

      <form
        onSubmit={handleSubmit(submitMe)}
        className="mt-7 bg-white gap-y-5 gap-x-[5%] text-black p-8 tall:py-[60px] xl:px-9 rounded-[18px] grid items-start xl:grid-cols-2"
      >
        <div className="grid gap-y-5 items-start">
          <div className="flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">CAMPAIGN TITLE</h6>

            <TextField
              className="admin_input_1"
              placeholder="Campaign title Name...."
              {...register("campaign_title", { required: true })}
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">PRODUCT TITLE</h6>

            <TextField
              className="admin_input_1"
              placeholder="Product title Name...."
              {...register("product_title", { required: true })}
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">
              PRODUCTION GOAL PRICE
            </h6>

            <TextField
              className="admin_input_1"
              placeholder="123456"
              type="number"
              {...register("production_goal_price", { required: true })}
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">
              PRODUCTION GOAL ORDER NUMBER
            </h6>
            <TextField
              className="admin_input_1"
              placeholder="123456"
              type="number"
              {...register("production_goal_order_number", { required: true })}
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">END GOAL PRICE</h6>

            <TextField
              className="admin_input_1"
              placeholder="123456"
              type="number"
              {...register("end_goal_price", { required: true })}
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">
              END GOAL ORDER NUMBER
            </h6>

            <TextField
              className="admin_input_1"
              placeholder="123456"
              type="number"
              {...register("end_goal_order_number", { required: true })}
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">MINIMUM QUANTITY</h6>

            <TextField
              className="admin_input_1"
              placeholder="123456"
              type="number"
              {...register("minimum_quantity", { required: true })}
            />
          </div>

          <h6 className="font-bold text-sm md:text-base">
            Select one or multiple categories
          </h6>

          <Select
            isMulti={true}
            options={categoriesList}
            value={selectedCategories}
            onChange={(e: any) => setCategories(e)}
            placeholder="Select one or multiple categories"
          />

          <h6 className="font-bold text-sm md:text-base">SIZE</h6>
          <Accordion
            expanded={true}
            className="!rounded-[10px] [border:1px_solid_#CCCCCC_!important] !m-0 [box-shadow:none_!important]"
          >
            <AccordionSummary
              className="!px-6"
              expandIcon={<div className="expand-icon-accordion"></div>}
              id="panel1a-header"
            >
              Select size
            </AccordionSummary>
            <AccordionDetails>
              <RadioGroup className="grid gap-4">
                <div className="flex items-center">
                  <Radio
                    onClick={() => setSizeType("ml")}
                    checked={selectedSizeType === "ml"}
                    value="ml"
                  />
                  <div className="flex items-center gap-3">
                    <TextField
                      className="admin_size_input"
                      onClick={() => setSizeType("ml")}
                      value={size_ml}
                      onChange={(e) => setSize_Ml(e.target.value)}
                    />
                    <span className="text-xs">ml</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <Radio
                    onClick={() => setSizeType("kg")}
                    checked={selectedSizeType === "kg"}
                    value="kg"
                  />
                  <div className="flex items-center gap-3">
                    <TextField
                      className="admin_size_input"
                      onClick={() => setSizeType("kg")}
                      value={size_kg}
                      onChange={(e) => setSize_Kg(e.target.value)}
                    />
                    <span className="text-xs">KGs</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <Radio
                    onClick={() => setSizeType("hwl")}
                    checked={selectedSizeType === "hwl"}
                    value="hwl"
                  />
                  <div className="flex items-center gap-3">
                    <TextField
                      className="admin_size_input"
                      onClick={() => setSizeType("hwl")}
                      value={size_hwl}
                      onChange={(e) => setSize_Hwl(e.target.value)}
                    />
                    <span className="text-xs">HxWxL</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <Radio
                    onClick={() => setSizeType("size")}
                    checked={selectedSizeType === "size"}
                    value="size"
                  />
                  <div className="flex items-center gap-3">
                    <Select
                      isMulti={true}
                      onMenuOpen={() => setSizeType("size")}
                      options={[
                        { value: "S", label: "Small" },
                        { value: "M", label: "Medium" },
                        { value: "L", label: "Large" },
                      ]}
                      value={size}
                      onChange={(e:any) => {
                        setSize(e);
                        console.log(size);
                      }}
                      placeholder="Select an option"
                    />
                    <span className="text-xs">S,M,L,XL, XXL</span>
                  </div>
                </div>
                <div className="flex items-center">
                  <Radio
                    onClick={() => setSizeType("men")}
                    checked={selectedSizeType === "men"}
                    value="men"
                  />
                    <div className="flex items-center gap-3">
                    <Select
                      isMulti={true}
                      onMenuOpen={() => setSizeType("men")}
                      options={[
                      { value: 5, label: 5 },
                      { value: 5.5, label: 5.5 },
                      { value: 6, label: 6 },
                      { value: 6.5, label: 6.5 },
                      { value: 7, label: 7 },
                      { value: 7.5, label: 7.5 },
                      { value: 8, label: 8 },
                      { value: 8.5, label: 8.5 },
                      { value: 9, label: 9 },
                      { value: 9.5, label: 9.5 },
                      { value: 10, label: 10 },
                      { value: 10.5, label: 10.5 },
                      { value: 11, label: 11 },
                      { value: 11.5, label: 11.5 },
                      { value: 12, label: 12 },
                      { value: 13, label: 13 },
                      { value: 14, label: 14 },
                      ]}
                      value={size_men_shoe}
                      onChange={(e: MultiValue<{value: number, label: number}>) => setSize_Men(e)}
                      placeholder="Select an option"
                    />
                    <span className="text-xs">Men's Shoe</span>
                    </div>
                </div>
                <div className="flex items-center">
                  <Radio
                    onClick={() => setSizeType("women")}
                    checked={selectedSizeType === "women"}
                    value="women"
                  />
                  <div className="flex items-center gap-3">
                    <Select
                      isMulti={true}
                      onMenuOpen={() => setSizeType("women")}
                      options={[
                        { value: 5, label: 5 },
                        { value: 5.5, label: 5.5 },
                        { value: 6, label: 6 },
                        { value: 6.5, label: 6.5 },
                        { value: 7, label: 7 },
                        { value: 7.5, label: 7.5 },
                        { value: 8, label: 8 },
                        { value: 8.5, label: 8.5 },
                        { value: 9, label: 9 },
                        { value: 9.5, label: 9.5 },
                        { value: 10, label: 10 },
                        { value: 10.5, label: 10.5 },
                        { value: 11, label: 11 },
                        { value: 11.5, label: 11.5 },
                        { value: 12, label: 12 },
                        { value: 13, label: 13 },
                        { value: 14, label: 14 },
                      ]}
                      value={size_women_shoe}
                      onChange={(e:any) => setSize_Women(e)}
                      placeholder="Select an option"
                    />
                    <span className="text-xs">Women's Shoe</span>
                  </div>
                </div>
              </RadioGroup>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="grid gap-y-5 items-start">
          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">END DATE</h6>

            <TextField
              min={moment().add(1, "day").format("YYYY-MM-DD")}
              type="date"
              className="admin_input_1"
              {...register("campaign_deadline", { required: true })}
            />
          </div>
          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">ADD LOCATION</h6>

            <TextField
              className="admin_input_1"
              placeholder="Accra, Ghana"
              {...register("location", { required: true })}
            />
            <FormControlLabel
              checked={isLocationExclusive === "yes"}
              onChange={() =>
                setIsLocationExclusive((prev) =>
                  prev === "yes" ? "no" : "yes"
                )
              }
              control={<Checkbox />}
              label="Is Location Excluxive"
            />
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">CURRENCY</h6>

            <RadioGroup defaultValue="GHS">
              <FormControlLabel
                value="GHS"
                control={<Radio {...register("currency")} />}
                label="GHS"
              />
              <FormControlLabel
                value="NGN"
                control={<Radio {...register("currency")} />}
                label="NGN"
              />
              <FormControlLabel
                value="ZAR"
                control={<Radio {...register("currency")} />}
                label="ZAR"
              />
            </RadioGroup>
          </div>

          <div className=" flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">CAMPAIGN IMAGES</h6>
            <DndProvider backend={HTML5Backend}>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-y-8">
                {campaignImages.map((image, index) => (
                  <DraggableImage
                    key={image.uuid}
                    image={image}
                    index={index}
                    moveImage={moveImage}
                    deleteImage={deleteImage}
                  />
                ))}
              </div>
            </DndProvider>
            <input
              id="image-upload"
              type="file"
              accept="image/*"
              multiple={true}
              onChange={handleNewImageUpload}
              className="hidden"
            />
            <label
              htmlFor="image-upload"
              className="bg-white border-black border text-black py-2 px-4 rounded-md cursor-pointer inline-block text-center mt-4 hover:scale-[1.02] transition-all"
            >
              Add Images
            </label>
            {/* <div className="grid grid-cols-2 gap-4">
              {imageUrls?.split(",").map((image, index) => {
                // console.log(imageUrls);
                return <img key={index} src={image} alt="Campaign Image" />;
              })}
              <input
                id="image-upload"
                type="file"
                accept="image/*"
                multiple={true}
                onChange={handleImageUpload}
              />
            </div> */}
          </div>

          <div className="flex flex-col gap-5 w-full">
            <h6 className="font-bold text-sm md:text-base">
              CAMPAIGN DESCRIPTION
            </h6>
            <div className="relative grid">
              <TextField
                multiline
                rows={6}
                className="admin_input_1 admin_textarea"
                {...register("campaign_description", { required: true })}
              />
              <button
                type="button"
                className="bg-[#0E203F] absolute bottom-6 right-4 text-white flex items-center gap-2 py-2 px-4 rounded-md  focus:outline-none focus:shadow-outline transform transition duration-300 perspective-origin-center hover:-rotate-y-6 hover:scale-[1.01] active:rotate-y-180 active:scale-100"
              >
                <FaCamera />
                <span>Add Photos</span>
              </button>
            </div>
          </div>

          <BlackButton
            text={uuid ? "Edit Campaign" : "Submit"}
            type="submit"
            // isDisabled={!isValid || !campaignImages.length}
            // isDisabled={!campaignImages.length || !selectedSizeTypes.length}
            isDisabled={!campaignImages.length || !selectedSizeType}
            className="max-w-[200px]"
            isLoading={loading}
          />

          {uuid && (
            <div className="flex flex-col gap-5 w-full border-t border-black pt-5 mt-5">
              <h6 className="font-bold text-sm md:text-base">
                ADD CAMPAIGN UPDATES
              </h6>
              {updateImage && (
                <div>
                  <img src={updateImage} alt="" />
                </div>
              )}
              <div className="flex gap-3 md:gap-5 w-full">
                <label
                  htmlFor="updateFileInput"
                  className="bg-[#0E203F] text-white cursor-pointer h-[30px] md:h-[44px] aspect-square rounded-full flex justify-center items-center"
                >
                  <FaCamera className="text-xs sm:text-base" />
                </label>
                <input
                  type="file"
                  id="updateFileInput"
                  onChange={handleUpdateImage}
                  className="hidden"
                />
                <TextField
                  multiline
                  rows={6}
                  value={updatesField}
                  onChange={(e) => setUpdatesField(e.target.value)}
                  className="admin_input_1 flex-1"
                />
              </div>
              <div className="mx-auto">
                <button
                  type="button"
                  onClick={() => {
                    submitUpdate();
                  }}
                  className="bg-[#0E203F] text-white py-2 px-4 rounded-md  focus:outline-none focus:shadow-outline transform transition duration-300 perspective-origin-center hover:-rotate-y-6 hover:scale-[1.01] active:rotate-y-180 active:scale-100"
                >
                  Post Campaign Update
                </button>
              </div>
            </div>
          )}
        </div>
      </form>
    </section>
  );
};
